import { render } from "./LanguageMultiDropdown.vue?vue&type=template&id=23f4928d&scoped=true"
import script from "./LanguageMultiDropdown.vue?vue&type=script&lang=ts"
export * from "./LanguageMultiDropdown.vue?vue&type=script&lang=ts"

import "./LanguageMultiDropdown.vue?vue&type=style&index=0&id=23f4928d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23f4928d"

export default script